import { createStyles, makeStyles } from '@material-ui/core';

const styles = () => {
    return createStyles({
        root: {
            paddingTop: 1,
        },
    });
};

export default makeStyles(styles, { name: 'MuiOutlinedEditor' });
